import { useEffect, useState } from 'react'

function isTouchDevice(): boolean {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    ('msMaxTouchPoints' in navigator && (navigator as { msMaxTouchPoints: number }).msMaxTouchPoints > 0)
  )
}

function useIsTouchDevice() {
  const [touchDevice, setTouchDevice] = useState<boolean | null>(null)
  useEffect(() => {
    setTouchDevice(isTouchDevice())
  }, [])
  return touchDevice
}

export default useIsTouchDevice
